/* /assets/recipes.js */
function showMoreRecipes(itemId) {
  var item = document.getElementById(itemId);
  var additionalLinks = item.getElementsByClassName('additional-recipe-link');
  for (var i = 0; i < additionalLinks.length; i++) {
    additionalLinks[i].style.display = 'list-item';
  }
  var button = item.getElementsByClassName('show-more-button')[0];
  if (button) {
    button.style.display = 'none';
  }
  item.style.height = 'auto';
}
